import { UseMutationResult, useMutation } from '@tanstack/react-query';

import { PrintLabelEntityTypes } from '../@types/print-label.type';
import { getPrintLabel } from '../api/printLabel';

export const useGetPrintLabel = (
  entityId: number,
  entityType: PrintLabelEntityTypes
): UseMutationResult<string, Error, void> => {
  return useMutation({
    mutationFn: async () => {
      return await getPrintLabel(entityType, entityId);
    },
  });
};
